import { userRoles } from "./constants";

export const isUserSeller = (user) => (user === null ? false : user.roleId === userRoles.seller);

export const isUserDriver = (user) => (user === null ? false : user?.roleId === userRoles.driver);

export const getUserRoleIds = (user) => {
  if (!user) return [];
  if (Array.isArray(user.userRole) && user.userRole.length) {
    return user.userRole.map((role) => role.roleId);
  }
  return user.roleId != null ? [user.roleId] : [];
};

export const hasRole = (user, roleId) => getUserRoleIds(user).includes(roleId);

export const canSwitchRole = (user) =>
  hasRole(user, userRoles.admin) && hasRole(user, userRoles.driver);

// tech has full access to every refund action and is the only department that manages admin users
export const isUserTech = (user) => user?.tech === true;
const isTech = isUserTech;

export const canProcessRefund = (user) =>
  isTech(user) || user?.finance === true || user?.customerCare === true;

// Refund approval flow: customer care requests, ops approves, finance processes
export const canRequestRefund = (user) => isTech(user) || user?.customerCare === true;
export const canApproveRefund = (user) => isTech(user) || user?.ops === true;
export const canProcessRefundRequest = (user) => isTech(user) || user?.finance === true;
// Anyone can view refund requests; only the actions above are restricted.

export const switchActiveRole = (targetRoleId) => {
  const user = JSON.parse(localStorage.getItem("user")) ?? {};
  const updatedUser = { ...user, roleId: targetRoleId };
  localStorage.setItem("user", JSON.stringify(updatedUser));
  return updatedUser;
};
